import React from 'react';
import cx from 'classnames';
import styles from './Card.module.scss';

function CardTitle(props) {
  const { className, children, stylesForSpan, innerRef, ...rest } = props;
  return (
    <div className={cx(styles.title, className)} {...rest} ref={innerRef}>
      <span style={stylesForSpan} className={styles.titleText}>
        {children}
      </span>
    </div>
  );
}

export default CardTitle;
